<template>
  <div class="safeProduction">
    <div class="index-header">
      <span class="title">
        <i class="el-icon-caret-right"></i>安全生产检查
      </span>
      <!-- <span class="other more" @click="equAdministrationAccount">【重点危险源台账】</span> -->
      <span class="other more" @click="equAdministrationAccount()">
        更多
        <i class="el-icon-d-arrow-right"></i>
      </span>
    </div>
    <div class="safeProduction-main">
      <!-- 饼图 -->
      <div class="myChartSafeProduction-father">
        <div class="myChartSafeProduction" :style="{width: '120px', height: '120px'}">
          <div>
            <h1 class="totalNum" @click="enterequAdministration">{{data.EaFacilitySum}}</h1>
            <h5>设备总数</h5>
          </div>
        </div>
      </div>
      <div class="vertaline">
        <div></div>
      </div>
      <!-- 安全生产 -->
      <div class="productType">
        <div class="productType1">
          <div>
            <span class="FontSize">
              本小区已安全生产
              <span class="fontBlue">{{data.SecurityCheckDayNum}}</span>天
            </span>
          </div>
        </div>
        <div class="productType2">
          <span class="FontSize">电梯</span>
          <span class="FontSize">安防</span>
          <span class="FontSize">消防</span>
        </div>
        <div class="productType3">
          <div class="svgMragin">
            <svg-icon icon-class="Elevator" class="iconstyle"></svg-icon>
            <span class="numFontSizeBlue">{{data.ElevatorNum}}</span>
          </div>
          <div class="svgMragin">
            <svg-icon icon-class="Security" class="iconstyle"></svg-icon>
            <span class="numFontSizeBlue">{{data.SecurityNum}}</span>
          </div>
          <div class="svgMragin">
            <svg-icon icon-class="fireProtection" class="iconstyle"></svg-icon>
            <span class="numFontSizeBlue">{{data.FireControlNum}}</span>
          </div>
        </div>
      </div>
      <!-- <div class="vertaline">
        <div></div>
      </div>-->
      <!-- 设备概况 -->
      <!-- <div class="productStauts">
        <div class="productStauts1">
          <div>
            <span class="FontSize">目前设施设备概况</span>
          </div>
        </div>
        <div class="productStauts2">
          <div class="productStauts2-child">
            <div class="productStauts2-child-son">
              <div>
                <span class="FontSize">报修数</span>
              </div>
              <div>
                <span class="FontSize">未处理</span>
              </div>
            </div>
            <div class="productStauts2-child-son number">
              <div>
                <span class="numFontSizeBlue" @click="enterRepair">{{data.GuaranteeNum}}</span>
              </div>
              <div>
                <span
                  class="numFontSizeBlue fontRed"
                  @click="enterRepair"
                >{{data.UntreatedGuaranteeNum}}</span>
              </div>
            </div>
          </div>
          <div class="vertalineShort">
            <div></div>
          </div>
          <div class="productStauts2-child">
            <div class="productStauts2-child-son">
              <div>
                <span class="FontSize">巡检数</span>
              </div>
              <div>
                <span class="FontSize">超期</span>
              </div>
            </div>
            <div class="productStauts2-child-son number">
              <div>
                <span class="numFontSizeBlue" @click="enterPatrol">{{data.FacilityCheckNum}}</span>
              </div>
              <div>
                <span
                  class="numFontSizeBlue fontRed"
                  @click="enterPatrol"
                >{{data.OverdueFacilityCheckNum}}</span>
              </div>
            </div>
          </div>
          <div class="vertalineShort">
            <div></div>
          </div>
          <div class="productStauts2-child">
            <div class="productStauts2-child-son">
              <div>
                <span class="FontSize">维保数</span>
              </div>
              <div>
                <span class="FontSize">超期</span>
              </div>
            </div>
            <div class="productStauts2-child-son number">
              <div>
                <span class="numFontSizeBlue" @click="enterMaintenance">{{data.MaintainNum}}</span>
              </div>
              <div>
                <span
                  class="numFontSizeBlue fontRed"
                  @click="enterMaintenance"
                >{{data.OverdueMaintainNum}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>-->
    </div>
  </div>
</template>

<script>
import commonTitle from '@/assets/js/commonTitle.js';
import { SecurityCheckControllerSvr } from '@/service/SecurityCheckControllerSvr/SecurityCheckControllerSvr.js';
import { mapState } from 'vuex';

export default {
  components: {},
  props: {},
  data() {
    return {
      data: {},
      Position: 'running'
    };
  },
  computed: {
    ...mapState(['token']),
    mainTitle: () => {
      return commonTitle;
    }
  },
  created() {
    this.securityCheckControllerSvr = new SecurityCheckControllerSvr();
  },
  mounted() {
    // this.getdata();
  },
  methods: {
    getdata() {
      this.securityCheckControllerSvr
        .GetSecurityCheckStaData(this.token, 1051010401000066)
        .then(res => {
          this.data = res;
        });
    },
    equAdministrationAccount() {
      //this.$router.push('/equAdministrationAccount');
      this.$router.push('/SafeProductionCheckList');
    },
    enterequAdministration() {
      this.$router.push('/equAdministration');
    },
    enterRepair() {
      this.$router.push('/repairMge');
    },
    enterPatrol() {
      this.$router.push('/patrolRecordList');
    },
    enterMaintenance() {
      this.$router.push('/maintenanceMge');
    }
  }
};
</script>
<style lang="scss">
@import './css/common.scss';
.safeProduction {
  background-color: #fff;
  .index-header {
    .more {
      color: blue;
    }
  }
  .safeProduction-main {
    background-color: #fff;
    display: flex;
    overflow: hidden;
    .myChartSafeProduction-father {
      display: flex;
      width: 40%;
      min-width: 200px;
      height: 210px;
      align-items: center;
      justify-content: center;
      .myChartSafeProduction {
        border: 7px #0f77f2 solid;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        align-content: center;
        div {
          text-align: center;
          h1 {
            cursor: pointer;
            margin: 0;
            color: #0f77f2;
            width: 52px;
            height: 30px;
            font-family: MicrosoftYaHei-Bold;
            font-size: 30px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #0f77f2;
          }
          h5 {
            margin-top: 11px;
            width: 52px;
            text-align: center;
            height: 13px;
            font-family: MicrosoftYaHei;
            font-size: 12px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #333333;
          }
        }
      }
    }
    .productType {
      width: 60%;
      min-width: 300px;
      .productType1 {
        text-align: center;
        margin-top: 40px;
        display: flex;
        justify-content: center;
      }
      .productType2 {
        text-align: center;
        margin-top: 30px;
        display: flex;
        justify-content: space-around;
      }
      .productType3 {
        text-align: center;
        margin-top: 20px;
        display: flex;
        justify-content: space-around;
        //图标对齐
        .svgMragin {
          display: flex;
          align-items: flex-end;
          justify-content: center;
        }
      }
    }
    .productStauts {
      width: 40%;
      min-width: 300px;
      .productStauts1 {
        text-align: center;
        margin-top: 40px;
      }
      .productStauts2 {
        display: flex;
        text-align: center;
        justify-content: space-around;
        margin-top: 30px;
        .productStauts2-child {
          width: 30%;
          .productStauts2-child-son {
            display: flex;
            justify-content: space-around;
          }
          .number {
            margin-top: 20px;
          }
        }
      }
      .productStauts3 {
        text-align: center;
        margin-top: 20px;
      }
    }
    //长竖线
    .vertaline {
      width: 1%;
      height: 210px;
      div {
        width: 1px;
        height: 80%;
        background-color: #e2e2e2;
        margin-top: 21px;
      }
    }
    //短竖线
    .vertalineShort {
      width: 1%;
      height: 50px;
      div {
        width: 1px;
        height: 100%;
        background-color: #e2e2e2;
      }
    }
    //数字样式
    .numFontSizeBlue {
      width: 27px;
      height: 18px;
      font-family: MicrosoftYaHei-Bold;
      font-size: 22px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #0f77f2;
      cursor: pointer;
    }
    //字体样式
    .FontSize {
      width: 26px;
      height: 14px;
      font-family: MicrosoftYaHei;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: -1px;
      color: #333333;
    }
    //红色
    .fontRed {
      color: #ff4546;
    }
    //蓝色
    .fontBlue {
      color: #0f77f2;
    }
    .margintop {
      margin-top: 20px;
    }
  }
}
</style>